import request from '@/utils/request'

const basePath = '/api/ai_review'

export function getAiReviewSaveReviewRuleUri() {
    return '/api/ai_review/question_application';
}

export function getAiReviewQuestionReviewListUri(examId, examPaperId) {
    return '/api/ai_review/exam/' + examId + '/paper/' + examPaperId + '/review_list';
}

export function getAiReviewQuestionReviewUri(reviewerQuestionId) {
    return '/api/ai_review/exam/paper/reviewer_question/' + reviewerQuestionId + '/review';
}

/**
 * 获取ai评阅配置
 * @returns {*}
 */
export function getConfig() {
    return request({
        url: `${basePath}/config`,
        method: 'GET'
    })
}

/**
 * 根据题目ids获取题目和应用管理关系
 * @param questionIds 题目id，用“,”分割
 * @returns {AxiosPromise}
 */
export function getApplicationByQuestionIds(questionIds) {
    return request({
        url: `${basePath}/question_application/question/ids`,
        method: 'GET',
        params: {
            ids: questionIds
        }
    })
}